'use client'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'

export function PostHogPageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()

  useEffect(() => {
    let url = ''
    if (posthog && pathname) {
      url = window.origin + pathname
      const query = searchParams.toString()
      if (query) url += `?${query}`
      posthog.capture('$pageview', { $current_url: url })
    }

    return () => {
      posthog.capture('$pageleave', { $current_url: url })
    }
  }, [pathname, searchParams, posthog])

  return null
}
